import * as React from "react";
import Spinner from "react-bootstrap/Spinner";
import Table from "react-bootstrap/Table";
import Form from "react-bootstrap/Form";
import { FieldEntry } from "../../interfaces/FieldEntry";
import ReactPaginate from 'react-paginate';
import { Config } from "../../App";

interface TableComponentProps {
    tableFilter: string;
    fieldFilter: string;
    wholeWords: boolean;
}

interface TableComponentState {
    fields: FieldEntry[];
    currentPage: number;
    highlightTables: boolean;
    highlightFields: boolean;
    showEverything: boolean;
}

const ITEMS_PER_PAGE = 250;

export default class TableComponent extends React.Component<TableComponentProps, TableComponentState> {

    constructor(props: TableComponentProps) {
        super(props);
        this.state = { fields: [], currentPage: 0, highlightFields: false, highlightTables: false, showEverything: false };
    }

    componentDidMount() {
        this.GetFields();
    }

    componentWillReceiveProps() {
        this.setState({currentPage: 0});
    }

    private GetFields() {
        fetch(Config().baseName + "/data/fields.json")
            .then(resp => resp.json())
            .then(resp => this.setState({ fields: resp }));
    }

    private GetFilteredFields(everything: boolean) {
        const {currentPage, fields} = this.state;
        const {tableFilter, fieldFilter} = this.props;

        //const fields = JSON.parse(JSON.stringify(this.state.fields));

        let newFields = [...fields];
            
        if (tableFilter) 
            newFields = newFields.filter(field => {
                const {oldTableName, tableName} = field;

                if (!this.props.wholeWords) {
                    if (oldTableName.toLowerCase().indexOf(tableFilter.toLowerCase()) !== -1) return true;
                    if (tableName.toLowerCase().indexOf(tableFilter.toLowerCase()) !== -1) return true;
                } else {
                    if (oldTableName.toLowerCase() === tableFilter.toLowerCase()) return true;
                    if (tableName.toLowerCase() === tableFilter.toLowerCase()) return true;
                }

                return false;
            });

        if (fieldFilter)
            newFields = newFields.filter(field => {
                
                const {oldFieldName, fieldName} = field;

                if (!this.props.wholeWords) {
                    if (oldFieldName.toLowerCase().indexOf(fieldFilter.toLowerCase()) !== -1) return true;
                    if (fieldName.toLowerCase().indexOf(fieldFilter.toLowerCase()) !== -1) return true;
                } else {
                    if (oldFieldName.toLowerCase() === fieldFilter.toLowerCase()) return true;
                    if (fieldName.toLowerCase() === fieldFilter.toLowerCase()) return true;
                }

                
                return false;
            });
        
        if (!everything) {
            newFields = [...newFields.slice((currentPage) * ITEMS_PER_PAGE, (currentPage) * ITEMS_PER_PAGE + ITEMS_PER_PAGE)];
        }
        return newFields;
    }

    private GetHighlights(field: FieldEntry, isTable: boolean) {
        if ((field.oldFieldName !== field.fieldName) && this.state.highlightFields && !isTable) return "table-warning";
        if ((field.oldTableName !== field.tableName) && this.state.highlightTables && isTable) return "table-warning";

        return "";
    }

    private showAllWarning() {
        if (!this.state.showEverything) {
            if(confirm("Opravdu chcete zobrazit všechny položky? Akce budou trvat delší dobu.")) {
                this.setState({showEverything: true, fields: []});
                this.GetFields();
            }
        } else {
            this.setState({showEverything: false, fields: []});
            this.GetFields();
        }
    }

    render() {

        if (this.state.fields.length == 0) {
            return <div className="d-flex flex-column align-items-center mt-3">
                
                <Spinner animation="grow" variant="success" />
                <b>Načítání dat</b>
            </div>
        } else {
            return <>
                <div className="d-flex justify-content-between flex-wrap flex-md-row flex-column">
                    <Form inline className={this.state.showEverything&&"my-3"}>
                        <Form.Group>
                            <Form.Check type="switch" label="Změněné tabulky" id="highlight-tables" className="mr-3" checked={this.state.highlightTables} onChange={() => this.setState({highlightTables: !this.state.highlightTables})} />
                        </Form.Group>
                        <Form.Group>
                            <Form.Check type="switch" label="Změněné pole" id="highlight-fields" className="mr-3" checked={this.state.highlightFields} onChange={() => this.setState({highlightFields: !this.state.highlightFields})} />
                        </Form.Group>
                        <Form.Group>
                            <Form.Check type="switch" label="Zobrazit vše" id="show-everything" checked={this.state.showEverything} onChange={this.showAllWarning.bind(this)} />
                        </Form.Group>
                    </Form>
                    {!this.state.showEverything&&this.renderPagination()}
                </div>
                <Table className="mt-3" hover striped>
                    <thead>
                        <tr className="table-sticky">
                            <th>Stará tabulka</th>
                            <th>Nová tabulka</th>
                            <th>Staré pole</th>
                            <th>Nové pole</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.GetFilteredFields(this.state.showEverything).map((field, i) => 
                            <tr key={i}>
                                <td className={this.GetHighlights(field, true)}>{field.oldTableName}</td>
                                <td className={this.GetHighlights(field, true)}>{field.tableName}</td>
                                <td className={this.GetHighlights(field, false)}>{field.oldFieldName}</td>
                                <td className={this.GetHighlights(field, false)}>{field.fieldName}</td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </>
        }
    }

    private renderPagination() {
        return <ReactPaginate 
            key={this.state.currentPage}
            pageCount={Math.ceil(this.GetFilteredFields(true).length/ITEMS_PER_PAGE)} 
            pageRangeDisplayed={5} 
            marginPagesDisplayed={2} 
            initialPage={this.state.currentPage}
            containerClassName="pagination mb-2 mt-3 pagination-sm"
            pageClassName="page-item"
            pageLinkClassName="page-link"
            activeClassName="page-item active"
            previousClassName="page-item"
            previousLinkClassName="page-link"
            nextClassName="page-item"
            nextLinkClassName="page-link"
            breakClassName="page-item"
            breakLinkClassName="page-link"
            nextLabel="&raquo;"
            previousLabel="&laquo;"
            onPageChange={a => this.setState({currentPage: a.selected})}
            

        />;
    }

}